import { generateClient } from 'aws-amplify/api';

const client = generateClient();

const onInputStatusNotification = `subscription OnInputStatusNotification($inputId: ID) {
  onInputStatusNotification(inputId: $inputId) {
    inputId
    type
    status
    timestamp
    dataJson
  }
}`;

const parseDataJson = (dataJson) => {
  if (!dataJson) return null;
  try {
    return JSON.parse(dataJson);
  } catch (e) {
    console.warn('Failed to parse notification dataJson:', e);
    return null;
  }
};

const state = {
  notifications: [],
  subscription: null,
};

const getters = {
  unreadCount: (state) => state.notifications.filter((n) => !n.read).length,
  allNotifications: (state) => state.notifications,
};

const mutations = {
  addNotification(state, notification) {
    state.notifications.unshift({
      ...notification,
      data: parseDataJson(notification.dataJson),
      read: false,
      receivedAt: new Date().toISOString(),
    });
  },
  markAsRead(state, index) {
    if (state.notifications[index]) {
      state.notifications[index].read = true;
    }
  },
  markAllAsRead(state) {
    state.notifications.forEach((n) => { n.read = true; });
  },
  clearAll(state) {
    state.notifications = [];
  },
  setSubscription(state, sub) {
    state.subscription = sub;
  },
};

const actions = {
  subscribe({ commit, dispatch }, inputId) {
    // Clean up any existing subscription first
    dispatch('unsubscribe');

    const variables = inputId ? { inputId } : {};

    try {
      const sub = client.graphql({
        query: onInputStatusNotification,
        variables,
        authMode: 'userPool',
      }).subscribe({
        next: ({ data }) => {
          const notification = data?.onInputStatusNotification;
          if (notification) {
            console.log('[Notifications] Received:', notification);
            commit('addNotification', notification);
          }
        },
        error: (err) => {
          console.error('[Notifications] Subscription error:', err);
          // Attempt reconnect after 5 seconds
          setTimeout(() => {
            console.log('[Notifications] Attempting reconnect...');
            dispatch('subscribe', inputId);
          }, 5000);
        },
      });

      commit('setSubscription', sub);
      console.log('[Notifications] Subscribed successfully', inputId ? `for inputId: ${inputId}` : '(global)');
    } catch (err) {
      console.error('[Notifications] Failed to create subscription:', err);
    }
  },

  unsubscribe({ state, commit }) {
    if (state.subscription) {
      state.subscription.unsubscribe();
      commit('setSubscription', null);
      console.log('[Notifications] Unsubscribed');
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
